import React from "react";

const amount = (value) => value === null || value === undefined ? "—" : String(value);

export default function ExportedCottageGoodsList({ goods, currency }) {
  return (
    <div className="overflow-x-auto" dir="rtl">
      <table className="w-full text-sm text-right border-collapse">
        <thead className="bg-slate-100">
          <tr>
            {["ردیف", "تعرفه", "شرح کالا", "تعداد", "وزن خالص / ناخالص (کیلوگرم)",
              "بسته‌بندی", `ارزش (${currency || "ارز اظهارنامه"})`, "ارزش گمرکی (ریال)",
              "حقوق و عوارض (ریال)"].map((label) => (
              <th key={label} className="p-3 whitespace-nowrap">{label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {goods.map((good) => (
            <tr key={good.id} className="border-b border-slate-200">
              <td className="p-3">{good.ntsw_item_number}</td>
              <td className="p-3">{good.HSCode || "—"}</td>
              <td className="p-3 min-w-48">{good.goods_description || "—"}</td>
              <td className="p-3">{amount(good.quantity)}</td>
              <td className="p-3 whitespace-nowrap">{amount(good.netweight)} / {amount(good.grossweight)}</td>
              <td className="p-3 whitespace-nowrap">{amount(good.package_count)} {good.package_type}</td>
              <td className="p-3">{amount(good.total_value)}</td>
              <td className="p-3">{amount(good.customs_value)}</td>
              <td className="p-3">
                <details>
                  <summary className="cursor-pointer">{amount(good.duty_total)}</summary>
                  <dl className="mt-2 min-w-40 space-y-1">
                    {[["حقوق گمرکی", good.customs_duty], ["هلال احمر", good.red_crescent],
                      ["ارزش افزوده", good.added_value], ["تخفیف", good.discount],
                      ["سایر عوارض", good.other_duties]].map(([label, value]) => (
                      <div key={label} className="flex justify-between gap-3"><dt>{label}</dt><dd>{amount(value)}</dd></div>
                    ))}
                  </dl>
                </details>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
